/**
 * Client-side plugin to load public images mapping.
 * This makes the mapping available to client-side composables.
 */
export default defineNuxtPlugin(async () => {
  // Try to load the mapping file
  // If it doesn't exist yet (before first sync), use empty object
  try {
    // @ts-ignore - dynamic import of JSON
    const module = await import('~/data/public-images.json').catch(() => null)
    const publicImagesMapping = module?.default || module || {}
    // Store in a global that the composable can access
    if (import.meta.client) {
      // @ts-ignore
      window.__publicImagesMapping = publicImagesMapping || {}
    }
  } catch (e) {
    // If file doesn't exist, use empty object
    if (import.meta.client) {
      // @ts-ignore
      window.__publicImagesMapping = {}
    }
  }
})

